/**
 * useReloadBlocker — hold the page's reload-safety gate shut while reloading would lose work
 * (WEB-APP-VERSION-REFRESH-001).
 *
 * A dirty form needs no call: page-shell's `useBeforeUnloadWarning` registers it. This is for work no form represents, such as an
 * open sale, whose cart lives only in memory:
 *
 * ```js
 * useReloadBlocker(items.length > 0 || payments.length > 0, RELOAD_BLOCK_REASON.SALE_IN_PROGRESS);
 * ```
 *
 * @module @puffin-core/api-client/useReloadBlocker
 */

import { useEffect } from 'react';

import { getPageReloadSafetyGate } from './reloadSafetyGate.js';

/**
 * @param {boolean} active - true while reloading would lose work
 * @param {string} reason - one of `RELOAD_BLOCK_REASON` (the notice names it)
 * @returns {void}
 */
export function useReloadBlocker(active, reason) {
  useEffect(() => {
    if (!active) return undefined;
    return getPageReloadSafetyGate().block(reason);
  }, [active, reason]);
}

export default useReloadBlocker;
